// The five insights destinations — design workspace pwa-design@insights.
// Kept out of the component files (Fast Refresh) and shared by the mobile
// InsightsTabBar and the section registration.
import {
  IconChartBar,
  IconFileText,
  IconMessage,
  IconStar,
  IconUser,
  type TablerIcon,
} from '@tabler/icons-react'

export interface InsightsNavItem {
  to: string
  label: string
  Icon: TablerIcon
}

export const INSIGHTS_NAV: InsightsNavItem[] = [
  { to: '/insights/speech', label: 'Прямая речь', Icon: IconMessage },
  { to: '/insights/progress', label: 'Ваш прогресс', Icon: IconChartBar },
  { to: '/insights/topics', label: 'Частые темы', Icon: IconFileText },
  { to: '/insights/strengths', label: 'Сильные стороны', Icon: IconStar },
  { to: '/insights/self', label: 'Как Вы себя видите', Icon: IconUser },
]
